import request from '@/config/axios'

// 品牌集团 VO
export interface BrandGroupVO {
  id: string | number
  name: string
  code: string
  logo: string
  country: string
  website: string
  description: string
  status: number
  sort: number
  createTime: Date
}

// 获取品牌集团分页
export function getBrandGroupPage(params: any) {
  return request.get({ url: '/hotel/brand-group/page', params })
}

// 获取品牌集团详情
export function getBrandGroup(id: string | number) {
  return request.get({ url: '/hotel/brand-group/get?id=' + id })
}

// 创建品牌集团
export function createBrandGroup(data: BrandGroupVO) {
  return request.post({ url: '/hotel/brand-group/create', data })
}

// 更新品牌集团
export function updateBrandGroup(data: BrandGroupVO) {
  return request.put({ url: '/hotel/brand-group/update', data })
}

// 删除品牌集团
export function deleteBrandGroup(id: string | number) {
  return request.delete({ url: '/hotel/brand-group/delete?id=' + id })
}
